import {
  ROLE_SUPER_ADMIN,
  ROLE_AUDITOR,
  ROLE_FINANCE,
  ROLE_OPERATOR,
  ROLE_ARBITER,
  ROLE_VIDEO_UPLOADER,
  ROLE_CONTENT_AUDITOR,
  MENU_CONFIG,
} from '../constants';

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  FORBIDDEN: '/403',
  NOT_FOUND: '/404',
  HOSPITAL_AUDIT: '/audit/hospitals',
  OPERATOR_AUDIT: '/audit/operators',
  GUIDE_AUDIT: '/audit/guides',
  AGENT_AUDIT: '/audit/agents',
  ARTICLE_AUDIT: '/audit/articles',
  USER_MANAGEMENT: '/customer/users',
  HOSPITAL_MANAGEMENT: '/customer/hospitals',
  OPERATOR_MANAGEMENT: '/customer/operators',
  GUIDE_MANAGEMENT: '/customer/guides',
  RELATION_MANAGEMENT: '/customer/relations',
  HOSPITAL_ADMIN: '/customer/hospital-admin',
  CUSTOMER_SOURCE_STATS: '/customer/source-stats',
  SERVICE_PRICE: '/service/prices',
  MEDICAL_CASE: '/service/medical-cases',
  COMPLAINT: '/service/complaints',
  COMPLAINT_DETAIL: '/service/complaints/:id',
  LINK_MANAGEMENT: '/service/links',
  LINK_DETAIL: '/service/links/:id',
  CHANNEL_QRCODES: '/channel/qrcodes',
  CHANNEL_QRCODE_USERS: '/channel/qrcodes/:id/users',
  CHANNEL_USERS: '/channel/users',
  CHAT_BOARD: '/monitor/chat',
  RISK_RULES: '/monitor/risk-rules',
  RISK_ALERTS: '/monitor/risk-alerts',
  PLATFORM_KNOWLEDGE: '/knowledge/platform',
  PUBLIC_HOSPITAL: '/knowledge/public-hospitals',
  RISK_KNOWLEDGE: '/knowledge/risk',
  KNOWLEDGE_CENTER: '/knowledge/center',
  RATE_CONFIG: '/settlement/rates',
  FINANCIAL_REPORT: '/settlement/reports',
  ORDER_MANAGEMENT: '/settlement/orders',
  RECHARGE_MANAGEMENT: '/settlement/recharges',
  WITHDRAWAL_MANAGEMENT: '/settlement/withdrawals',
  // 供应商提现审核（文档 9.2：life-service supplier_monthly_summaries，区别于运营主体提现）
  SUPPLIER_WITHDRAWALS: '/settlement/supplier-withdrawals',
  ACCOUNT_BALANCE: '/settlement/accounts',
  CONNECTION_CHARGE: '/settlement/connection-charge',
  REVENUE_STATS: '/settlement/revenue-stats',
  BALANCE_WARNINGS: '/settlement/balance-warnings',
  ROLE_MANAGEMENT: '/system/roles',
  OPERATION_LOG: '/system/logs',
  MEMBER_MANAGEMENT: '/system/members',
  // 平台配置（文档 9.4：接通价格/收款账户/客服联系/开票信息 四 Tab）
  PLATFORM_CONFIG: '/system/platform-config',
  // 加盟管理域（P0：后端接口已就绪）
  JOIN_APPLICATIONS: '/join/applications',
  JOIN_CONTRACTS: '/join/contracts',
  // 加盟管理域（P1/P2：接口契约先行，待后端补齐后联调）
  JOIN_ACCOUNTS: '/join/accounts',
  JOIN_TEMPLATES: '/join/templates',
  JOIN_SUPPLIERS: '/join/suppliers',
  JOIN_REPORTS: '/join/reports',
  // 社区运营域（P0：后端接口已就绪）
  LIFE_SUPPLIER_CERTS: '/life/supplier-certs',
  LIFE_ACTIVITIES: '/life/activities',
  LIFE_CONTENT_AUDIT: '/life/content-audit',
  LIFE_OPERATION: '/life/operation',
  // 社区内容管理（文档：管理后台社区内容管理改进需求文档 v1.3）
  LIFE_PUBLISH: '/life/publish',
  LIFE_VIDEO_UPLOAD: '/life/video-upload',
  LIFE_POSTS: '/life/posts',
  LIFE_NOTICES: '/life/notices',
  LIFE_COMMENTS: '/life/comments',
  // 社区运营域（P1/P2：接口契约先行，待后端补齐后联调）
  LIFE_USER_CERTS: '/life/user-certs',
  LIFE_SIGNUPS: '/life/signups',
  LIFE_ORDERS: '/life/orders',
  LIFE_POINTS_CONFIG: '/life/points-config',
  LIFE_ESCROW: '/life/escrow',
  LIFE_DASHBOARD: '/life/dashboard',
};

export const MENU_ITEMS = [
  {
    key: MENU_CONFIG.DASHBOARD,
    label: '仪表盘',
    icon: 'Dashboard',
    path: ROUTES.DASHBOARD,
    roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_FINANCE, ROLE_OPERATOR, ROLE_ARBITER],
  },
  {
    key: MENU_CONFIG.AUDIT_CENTER,
    label: '审核中心',
    icon: 'Audit',
    path: ROUTES.HOSPITAL_AUDIT,
    roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
    children: [
      {
        key: 'hospital_audit',
        label: '医院主体审核',
        path: ROUTES.HOSPITAL_AUDIT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'operator_audit',
        label: '运营主体审核',
        path: ROUTES.OPERATOR_AUDIT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'guide_audit',
        label: '医导员审核',
        path: ROUTES.GUIDE_AUDIT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'agent_audit',
        label: '智能体审核',
        path: ROUTES.AGENT_AUDIT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'article_audit',
        label: '文章审核',
        path: ROUTES.ARTICLE_AUDIT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
    ],
  },
  {
    key: MENU_CONFIG.CUSTOMER,
    label: '客户管理',
    icon: 'Team',
    path: ROUTES.USER_MANAGEMENT,
    roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
    children: [
      {
        key: 'user_management',
        label: '用户管理',
        path: ROUTES.USER_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'hospital_management',
        label: '医院主体管理',
        path: ROUTES.HOSPITAL_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'operator_management',
        label: '运营主体管理',
        path: ROUTES.OPERATOR_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'guide_management',
        label: '医导员管理',
        path: ROUTES.GUIDE_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'relation_management',
        label: '关系管理',
        path: ROUTES.RELATION_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'hospital_admin',
        label: '医院超级管理员管理',
        path: ROUTES.HOSPITAL_ADMIN,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'customer_source_stats',
        label: '客户来源统计',
        path: ROUTES.CUSTOMER_SOURCE_STATS,
        roles: [ROLE_SUPER_ADMIN],
      },
    ],
  },
  {
    key: MENU_CONFIG.SERVICE,
    label: '服务监管',
    icon: 'Monitor',
    path: ROUTES.SERVICE_PRICE,
    roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_FINANCE],
    children: [
      {
        key: 'service_price',
        label: '服务项目与价格',
        path: ROUTES.SERVICE_PRICE,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_FINANCE],
      },
      {
        key: 'medical_case',
        label: '医疗案例库',
        path: ROUTES.MEDICAL_CASE,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'complaint',
        label: '投诉管理',
        path: ROUTES.COMPLAINT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_FINANCE],
      },
      {
        key: 'link_management',
        label: '连接管理',
        path: ROUTES.LINK_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN],
      },
    ],
  },
  {
    key: MENU_CONFIG.CHANNEL,
    label: '渠道管理',
    icon: 'Qrcode',
    path: ROUTES.CHANNEL_QRCODES,
    roles: [ROLE_SUPER_ADMIN],
    children: [
      {
        key: 'channel_qrcodes',
        label: '渠道二维码',
        path: ROUTES.CHANNEL_QRCODES,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'channel_users',
        label: '渠道发展用户',
        path: ROUTES.CHANNEL_USERS,
        roles: [ROLE_SUPER_ADMIN],
      },
    ],
  },
  {
    key: MENU_CONFIG.KNOWLEDGE,
    label: '知识库管理',
    icon: 'Book',
    path: ROUTES.PLATFORM_KNOWLEDGE,
    roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
    children: [
      {
        key: 'knowledge_center',
        label: '知识库总览',
        path: ROUTES.KNOWLEDGE_CENTER,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'platform_knowledge',
        label: '平台通用知识库',
        path: ROUTES.PLATFORM_KNOWLEDGE,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'public_hospital',
        label: '公立医院库',
        path: ROUTES.PUBLIC_HOSPITAL,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'risk_knowledge',
        label: '风控知识库',
        path: ROUTES.RISK_KNOWLEDGE,
        roles: [ROLE_SUPER_ADMIN],
      },
    ],
  },
  {
    key: MENU_CONFIG.SETTLEMENT,
    label: '结算管理',
    icon: 'Finance',
    path: ROUTES.RATE_CONFIG,
    roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
    children: [
      {
        key: 'rate_config',
        label: '费率配置',
        path: ROUTES.RATE_CONFIG,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
      {
        key: 'financial_report',
        label: '财务报表',
        path: ROUTES.FINANCIAL_REPORT,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
      {
        key: 'order_management',
        label: '订单管理',
        path: ROUTES.ORDER_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
      {
        key: 'recharge_management',
        label: '充值记录',
        path: ROUTES.RECHARGE_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
      {
        key: 'withdrawal_management',
        label: '提现申请',
        path: ROUTES.WITHDRAWAL_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
      {
        // 供应商收益提现（文档 9.2，与上者运营主体提现为不同体系）
        key: 'supplier_withdrawals',
        label: '供应商提现',
        path: ROUTES.SUPPLIER_WITHDRAWALS,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
      {
        key: 'account_balance',
        label: '账户余额',
        path: ROUTES.ACCOUNT_BALANCE,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
      {
        key: 'connection_charge',
        label: '接通收费',
        path: ROUTES.CONNECTION_CHARGE,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'revenue_stats',
        label: '收益成本报表',
        path: ROUTES.REVENUE_STATS,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'balance_warnings',
        label: '余额预警记录',
        path: ROUTES.BALANCE_WARNINGS,
        roles: [ROLE_SUPER_ADMIN],
      },
    ],
  },
  {
    key: MENU_CONFIG.JOIN,
    label: '加盟管理',
    icon: 'Join',
    path: ROUTES.JOIN_APPLICATIONS,
    roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_OPERATOR],
    children: [
      {
        key: 'join_applications',
        label: '加盟申请审核',
        path: ROUTES.JOIN_APPLICATIONS,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'join_contracts',
        label: '合同管理',
        path: ROUTES.JOIN_CONTRACTS,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'join_accounts',
        label: '供应商账号管理',
        path: ROUTES.JOIN_ACCOUNTS,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'join_templates',
        label: '合同模板配置',
        path: ROUTES.JOIN_TEMPLATES,
        roles: [ROLE_SUPER_ADMIN, ROLE_OPERATOR],
      },
      {
        key: 'join_suppliers',
        label: '供应商管理',
        path: ROUTES.JOIN_SUPPLIERS,
        roles: [ROLE_SUPER_ADMIN, ROLE_OPERATOR],
      },
      {
        key: 'join_reports',
        label: '加盟数据报表',
        path: ROUTES.JOIN_REPORTS,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_FINANCE, ROLE_OPERATOR, ROLE_ARBITER],
      },
    ],
  },
  {
    key: MENU_CONFIG.LIFE,
    label: '社区运营',
    icon: 'Life',
    path: ROUTES.LIFE_SUPPLIER_CERTS,
    // 新增视频上传专员/内容审核员两个内容岗角色（文档 R-ADM-ROLE-03）
    roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_OPERATOR, ROLE_FINANCE, ROLE_ARBITER, ROLE_VIDEO_UPLOADER, ROLE_CONTENT_AUDITOR],
    children: [
      {
        key: 'life_dashboard',
        label: '社区数据看板',
        path: ROUTES.LIFE_DASHBOARD,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_OPERATOR, ROLE_FINANCE, ROLE_ARBITER],
      },
      {
        key: 'life_supplier_certs',
        label: '供应商认证审核',
        path: ROUTES.LIFE_SUPPLIER_CERTS,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'life_user_certs',
        label: '实名认证审核',
        path: ROUTES.LIFE_USER_CERTS,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'life_activities',
        label: '活动审核',
        path: ROUTES.LIFE_ACTIVITIES,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR],
      },
      {
        key: 'life_content_audit',
        label: '内容审核',
        path: ROUTES.LIFE_CONTENT_AUDIT,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_CONTENT_AUDITOR],
      },
      // 社区内容管理菜单（文档：管理后台社区内容管理改进需求文档 v1.3）
      {
        key: 'life_publish',
        label: '发布动态',
        path: ROUTES.LIFE_PUBLISH,
        roles: [ROLE_SUPER_ADMIN, ROLE_OPERATOR],
      },
      {
        key: 'life_video_upload',
        label: '视频上传',
        path: ROUTES.LIFE_VIDEO_UPLOAD,
        roles: [ROLE_SUPER_ADMIN, ROLE_VIDEO_UPLOADER],
      },
      {
        key: 'life_posts',
        label: '动态管理',
        path: ROUTES.LIFE_POSTS,
        roles: [ROLE_SUPER_ADMIN, ROLE_CONTENT_AUDITOR],
      },
      {
        key: 'life_notices',
        label: '供应商消息管理',
        path: ROUTES.LIFE_NOTICES,
        roles: [ROLE_SUPER_ADMIN, ROLE_CONTENT_AUDITOR],
      },
      {
        key: 'life_comments',
        label: '评论管理',
        path: ROUTES.LIFE_COMMENTS,
        roles: [ROLE_SUPER_ADMIN, ROLE_CONTENT_AUDITOR],
      },
      {
        key: 'life_signups',
        label: '报名监管',
        path: ROUTES.LIFE_SIGNUPS,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_FINANCE],
      },
      {
        key: 'life_orders',
        label: '活动订单监管',
        path: ROUTES.LIFE_ORDERS,
        roles: [ROLE_SUPER_ADMIN, ROLE_AUDITOR, ROLE_FINANCE, ROLE_ARBITER],
      },
      {
        key: 'life_points_config',
        label: '积分与会员配置',
        path: ROUTES.LIFE_POINTS_CONFIG,
        roles: [ROLE_SUPER_ADMIN, ROLE_OPERATOR],
      },
      {
        key: 'life_operation',
        label: '运营配置',
        path: ROUTES.LIFE_OPERATION,
        roles: [ROLE_SUPER_ADMIN, ROLE_OPERATOR],
      },
      {
        key: 'life_escrow',
        label: '资金担保与分账',
        path: ROUTES.LIFE_ESCROW,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
    ],
  },
  {
    key: MENU_CONFIG.SYSTEM,
    label: '系统设置',
    icon: 'Setting',
    path: ROUTES.ROLE_MANAGEMENT,
    // 财务因「平台配置」子项可见本组（其余子项各自限超管）
    roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
    children: [
      {
        key: 'role_management',
        label: '权限管理',
        path: ROUTES.ROLE_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'member_management',
        label: '成员管理',
        path: ROUTES.MEMBER_MANAGEMENT,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        key: 'operation_log',
        label: '操作日志',
        path: ROUTES.OPERATION_LOG,
        roles: [ROLE_SUPER_ADMIN],
      },
      {
        // 平台配置（文档 9.4）：接通价格/收款账户/客服联系/开票信息，财务参与维护
        key: 'platform_config',
        label: '平台配置',
        path: ROUTES.PLATFORM_CONFIG,
        roles: [ROLE_SUPER_ADMIN, ROLE_FINANCE],
      },
    ],
  },
];

export const getMenuItemsByRole = (role) => {
  const filterMenus = (items) => {
    return items
      .filter((item) => !item.roles || item.roles.includes(role))
      .map((item) => {
        if (item.children) {
          const filteredChildren = filterMenus(item.children);
          return { ...item, children: filteredChildren };
        }
        return item;
      })
      .filter((item) => !item.children || item.children.length > 0);
  };

  return filterMenus(MENU_ITEMS);
};
